module.exports = __webpack_public_path__ + "cd19764c2dd618c68779b751f32dd8ce.svg";